import { FC } from 'react'

import { colors } from '../../theme'
import Highlight, { HighlightProps } from '../Highlight'
import Collapsable, { CollapsableProps } from '../Collapsable'
import { ActionButtonProps } from '../ActionButton'
import Video, { VideoProps } from '../Video'
import StepCard, { StepProps } from '../StepCard'
import StepByStep, { StepByStepProps } from '../StepByStep'
import { ECollapsable } from '../Collapsable/types'
import FamilyStepByStep, { FamilyStepByStepProps } from '../Family/StepByStep'

import * as SC from './styled'

export type RecipeStepsSectionProps = {
  title?: string
  steps?: StepProps[]
  fullscreenStepsButtonProps: ActionButtonProps
  videoProps: VideoProps
  stepByStepProps: StepByStepProps
  highlightTitleProps?: HighlightProps
  collapsableProps?: CollapsableProps
  familyStepByStepProps?: FamilyStepByStepProps
  customStepRenderer?: (step: StepProps, index: number) => React.ReactNode
}

const RecipeStepsSection: FC<RecipeStepsSectionProps> = ({
  title,
  steps,
  fullscreenStepsButtonProps,
  videoProps,
  stepByStepProps,
  highlightTitleProps,
  collapsableProps,
  customStepRenderer,
  familyStepByStepProps,
}) => {
  return (
    <>
      <Collapsable
        header={
          title && (
            <SC.SectionTitle>
              <Highlight
                backgroundColor={
                  highlightTitleProps?.backgroundColor || colors.pink
                }
                color={highlightTitleProps?.color || colors.pureBlack}
                text={title}
              />
            </SC.SectionTitle>
          )
        }
        isCollapsable={ECollapsable.MOBILE}
        isOpenOnInit
        backgroundColor={collapsableProps?.backgroundColor}
        backgroundImage={collapsableProps?.backgroundImage}
      >
        <SC.Inner>
          {videoProps?.video?.src && <Video {...videoProps} />}
          <SC.FullscreenStepsButton {...fullscreenStepsButtonProps} />
          <SC.StepsContainer>
            {steps &&
              steps?.map((step, index: number) => {
                if (customStepRenderer) {
                  return customStepRenderer(step, index)
                }
                return (
                  <SC.Step key={`step-${index}`}>
                    <SC.StepNumber>{index + 1}</SC.StepNumber>
                    <SC.StepSeparator />
                    <SC.StepText>{step?.text}</SC.StepText>
                  </SC.Step>
                )
              })}
          </SC.StepsContainer>
        </SC.Inner>
      </Collapsable>
      {!familyStepByStepProps && (
        <StepByStep {...stepByStepProps}>
          {steps &&
            steps?.map((step, index) => {
              return <StepCard key={`StepCard-${index}`} {...step} />
            })}
        </StepByStep>
      )}
      {familyStepByStepProps && <FamilyStepByStep {...familyStepByStepProps} />}
    </>
  )
}

export default RecipeStepsSection
